import { MemoryCache } from './cache'

/**
 * Cache for void calls. Uses an internal sentinel because `getOrFetch` does
 * not persist null or undefined results.
 */
export class VoidMemoryCache<TKey> {
  private cache = new MemoryCache<TKey, true>()

  async call(
    key: TKey,
    fetcher: () => Promise<void>,
    useCacheResult: boolean
  ): Promise<void> {
    if (useCacheResult) {
      await this.cache.getOrFetch(key, () => fetcher().then(() => true as const))
      return
    }
    return fetcher()
  }
}
